import Booking from "@/components/sections/Booking";

export default function BookingPage() {
  return (
    <div className="pt-16 min-h-screen bg-wc-cream">
      <Booking />
    </div>
  );
}
